import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';

export function RollingInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Function</FieldLabel>
      <Segmented value={c.fn || 'avg'} onChange={(v) => u({ fn: v })}
        options={[
          { value: 'avg', label: 'Moving avg' },
          { value: 'sum', label: 'Rolling sum' },
          { value: 'min', label: 'Min' },
          { value: 'max', label: 'Max' },
        ]} />
      <FieldLabel>Window size (rows)</FieldLabel>
      <TextInput mono value={c.window ?? 7} type="number" onChange={(v) => u({ window: Number(v) })} />
      <FieldLabel hint={`Blank keeps the default name, ${c.column || 'col'}_rolling_${c.fn || 'avg'}`}>Output column</FieldLabel>
      <TextInput mono value={c.target || ''} onChange={(v) => u({ target: v })} placeholder={`${c.column || 'col'}_rolling_${c.fn || 'avg'}`} />
      {((c.fn || 'avg') === 'avg' || c.fn === 'sum') && (
        <DecimalPlacesField value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
      )}
    </div>
  );
}
